import React from "react";
import { Link } from "react-router-dom";
import vehicleBanner from "../../assets/vehicle-loan-banner.jpg";
import "./LoanProduct.css";

const VehicleLoan = () => {
  return (
    <main className="loan-page">
      <section className="loan-hero" style={{ backgroundImage: `url(${vehicleBanner})` }}>
        <div className="loan-hero-inner cb-rise">
          <h1>Drive ahead with the right vehicle loan partner</h1>
          <p>
            Core Bankers helps you connect with trusted banks and NBFCs for new and used vehicle loans.
            As a DSA, we guide you — we do not lend.
          </p>
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
        </div>
      </section>

      <div className="loan-content">
        <section className="loan-section">
          <h2>Why choose Core Bankers</h2>
          <ul>
            <li>Access to new and used vehicle loan options</li>
            <li>Partnered with RBI-registered banks and NBFCs</li>
            <li>Zero assistance fees from our side</li>
            <li>Support for salaried, self-employed, and business buyers</li>
            <li>Matching based on vehicle type and borrower profile</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Eligibility criteria</h2>
          <ul>
            <li>Applicants typically aged 21 to 65 years</li>
            <li>Minimum income as per lender policy</li>
            <li>Valid PAN, Aadhaar, and address proof</li>
            <li>Driving licence and Indian citizenship</li>
            <li>Sound credit score or repayment history</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Documents required</h2>
          <ul>
            <li>PAN Card and Aadhaar Card</li>
            <li>Recent salary slips / ITR returns</li>
            <li>Six months bank statement</li>
            <li>Address proof (utility bill / rent agreement)</li>
            <li>Vehicle quotation or invoice</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>How it works</h2>
          <ol>
            <li>Submit a vehicle loan enquiry</li>
            <li>We evaluate your needs and documents</li>
            <li>Lenders are matched based on eligibility</li>
            <li>Loan is disbursed after lender approval</li>
          </ol>
        </section>

        <section className="loan-cta">
          <h2>Finance your next vehicle with clarity</h2>
          <p>No pushy selling. No hidden charges from Core Bankers. Just structured DSA-backed guidance.</p>
          <Link to="/contact" className="cb-btn">
            Talk to us
          </Link>
        </section>
      </div>
    </main>
  );
};

export default VehicleLoan;
